function LatestActivitiesTableHeader() {
    return (
      <tr>
        <td>September 10</td>
        <td></td>
        <td></td>
      </tr>
    );
  }
  
  export { LatestActivitiesTableHeader };
  